import { render, staticRenderFns } from "./CommonQuestionOptionsForm.vue?vue&type=template&id=58c4f55a&scoped=true&"
import script from "./CommonQuestionOptionsForm.vue?vue&type=script&lang=js&"
export * from "./CommonQuestionOptionsForm.vue?vue&type=script&lang=js&"
import style0 from "./CommonQuestionOptionsForm.vue?vue&type=style&index=0&id=58c4f55a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c4f55a",
  null
  
)

export default component.exports